/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */



// Open Account Sidebar

$(document).on('click','[data-action="open-drawer-account"]',function(){
  	$("#sidebar-menu-account").attr('aria-hidden', 'false');
  	$(".PageOverlay").addClass('is-visible');
    $(".Search").attr('aria-hidden', 'true');
	$("html").addClass('no-scroll');
    $(".PageOverlayAccount").addClass('is-visible');
  	$("#shopify-section-header").css('z-index', 4);
});
  
$(document).on('click', '[data-action="close-drawer"]',function(){
  	$("#sidebar-menu-account").attr('aria-hidden', 'true');
    $(".PageOverlay").removeClass('is-visible');
	$("html").removeClass('no-scroll');
    $(".Search").attr('aria-hidden', 'true');
	$("#shopify-section-header").css('z-index', 4);
});

$(document).on('click', '[data-action="toggle-search"]',function(){
	//$("#shopify-section-header").css('z-index', 10);
	$(".PageOverlay").css('z-index', 5);
});

$(document).on('click', '[data-action="open-drawer"]',function(){
	$("#shopify-section-header").css('z-index', 4);
	$(".PageOverlay").css('z-index', 6);
});


$(document).on('click', '.PageOverlayAccount',function(){
	$(".PageOverlayAccount").removeClass('is-visible');
  
    $("#sidebar-menu-account").attr('aria-hidden', 'true');
    $(".PageOverlay").removeClass('is-visible');
	$("html").removeClass('no-scroll');
    $(".Search").attr('aria-hidden', 'true');
	$("#shopify-section-header").css('z-index', 4);
});


  // Tab Function
  // Get the container element
  var btnContainer = document.getElementById("button_wrap");


  // Get all buttons with class="btn" inside the container
  var classy = 'tab_button';
  var btns = ! document.getElementsByClassName(classy).length;

  if (btns == 0) {
    var btns = btnContainer.getElementsByClassName("tab_button");
  }

  // var btns = btnContainer.getElementsByClassName("tab_button");

  // Loop through the buttons and add the active class to the current/clicked button
  for (var i = 0; i < btns.length; i++) {
    btns[i].addEventListener("click", function() {
      var current = document.getElementsByClassName("active");
      current[0].className = current[0].className.replace(" active", "");
      this.className += " active";
    });
  }

  function openTab(tabName) {
    var i;
    var x = document.getElementsByClassName("tab");
    for (i = 0; i < x.length; i++) {
      x[i].style.display = "none";
    }
    document.getElementById(tabName).style.display = "block";
  }

  // Accordion Function
  var acc = document.getElementsByClassName("accordion");
  var reviewbutton = document.getElementsByClassName("accordion");
  var i;

  for (i = 0; i < acc.length; i++) {
    acc[i].addEventListener("click", function() {
      this.classList.toggle("active");
      var panel = this.nextElementSibling;
      if (panel.style.maxHeight) {
        panel.style.maxHeight = null;
      } else {
        panel.style.maxHeight = panel.scrollHeight + "%";
      }
       
    });
  }
  


// Sticky Function
if (document.querySelector('.CollectionToolbar') !== null) {
const stickyElm = document.querySelector('.CollectionToolbar')

const observer = new IntersectionObserver( 
  ([e]) => e.target.classList.toggle('isSticky', e.intersectionRatio < 1),
  {threshold: [1]}
);

observer.observe(stickyElm)

console.log('sticky');
}


// Zen Desk Styling
 window.zESettings = {
    webWidget: {
      color: { theme: '#efefef' }
    }
  };


// Move Stamped Hint inside Review Section
$( document ).ready(function() {
    $(".summary-hint-box").prependTo(".stamped-content .stamped-reviews");
  // If no reviews, hide hint box
  if (!$(".stamped-review-image").length){
    $(".summary-hint-box").hide();
}
  
});


// If hint Stamped title is empty, hide it
$(".summary-hint-box h5").each(function(){
    if (!$(this).text().trim().length) {
        $(".summary-hint-box").hide();
    }
});



// Update Add To Cart Counter on Click
$( ".Drawer__Close" ).click(function() {
       
  jQuery.getJSON('/cart.js', function(cart) {
       
  	$('.cartCount').html(cart.item_count);
  
  });

});


$( ".PageOverlay" ).click(function() {
        
  jQuery.getJSON('/cart.js', function(cart) {
  	$('.cartCount').html(cart.item_count);

  });

});
 

